import Response from "../../Data/Domain/Response";
import SDG from "../Domain/SDG";
import { getSDG } from "./SDG.service";

export async function getSDGRepository(params) {
  const data = await getSDG(params);
  return new Response(data, SDG).getMultiple();
}